import React, { useEffect, useState } from "react";
import UserFilter from "../../../../app/core/components/UserFilter/UserFilter";
import { useGetCommercialistaQuery } from "../../../api/admin/gestisciCommercialistiApi";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import { t } from "i18next";
import {
  useAddGroupAdminMutation,
  useRemoveGroupAdminMutation,
} from "../../../api/admin/gestisciStudioApi";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import { toast } from "react-toastify";
import { IconButton, Tooltip } from "@mui/material";
import PersonRemoveRoundedIcon from "@mui/icons-material/PersonRemoveRounded";

const DetailAdminGroup = ({ group, onClose }) => {
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [debouncedValue, setDebouncedValue] = useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const { data, isLoading } = useGetCommercialistaQuery({
    page,
  });

  const [addGruopAdmin, { isLoading: isLoadingSave }] =
    useAddGroupAdminMutation();

  const [removeGroupAdmin] = useRemoveGroupAdminMutation();

  useEffect(() => {
    if (group?.groupAdminId) {
      setSelectedOperator({
        id: group.groupAdminId,
        label: group.groupAdminName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group?.groupAdminId]);

  const handleSaveAdminGroup = () => {
    const addAdminToGroup = {
      adminid: selectedOperator?.id,
      studioGroupId: group?.id,
    };

    addGruopAdmin(addAdminToGroup)
      .then((res) => {
        if (res.data.Exception) {
          toast.error(res.data.Exception);
        } else if (res.data.Data) {
          toast.success(`${t("GroupAdminSaved")}`);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleRemoveAdminGroup = () => {
    const addAdminToGroup = {
      adminid: selectedOperator?.id,
      studioGroupId: group?.id,
    };

    removeGroupAdmin(addAdminToGroup)
      .then((res) => {
        if (res.data.Exception) {
          toast.error(res.data.Exception);
        } else if (res.data.Data) {
          toast.success(`${t("GroupAdminSaved")}`);
        }
      })
      .catch((error) => {
        toast.error(error);
      });

    onClose();
  };

  return (
    <div className="flex flex-col items-center">
      <h3>{t("DetailAdminGroup") + " " + group.name}</h3>
      <div className="flex items-center w-2/3 mt-5 space-x-4">
        <UserFilter
          selectedUser={selectedOperator}
          setSelectedUser={setSelectedOperator}
          usersList={data?.Data?.items}
          setDebouncedInputUserValue={setDebouncedValue}
          isUsersLoading={isLoading}
          setPage={setPage}
          externalLabel={`${t("BriefSearchOperator")}`}
          externalPlaceholder={`${t("ExtSearchOperator")}`}
          externalNegativeLabel={t("NoOperatorFound")}
        />
        {group.groupAdminId && (
          <Tooltip title={t("DeleteAdminGroup")}>
            <IconButton variant="outlined" onClick={handleRemoveAdminGroup}>
              <PersonRemoveRoundedIcon className={"fill-rose-600"} />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className="w-full flex justify-center mt-14 ">
        <CoreButton
          testo={isLoadingSave ? t("Wait") : t("Save")}
          className="btn-round"
          onClick={handleSaveAdminGroup}
          disabled={isLoadingSave || !selectedOperator}
        />
      </div>
    </div>
  );
};

export default DetailAdminGroup;
